import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import * as ModifyAPI from "./ModifyAPI";

const ModifySlice = createSlice({
  name: "Modify",
  initialState: {
    status: "idle",
    error: null,
    isModifying: false,
    propertyMod: false,
    procedureMod: false,
  },
  reducers: {
    setModifying: (state, action) => {
      state.isModifying = action.payload; // Update modifying state
    },
    setPropertyMod: (state, action) => {
      state.propertyMod = action.payload; // Update modifying state
    },
    setProcedureMod: (state, action) => {
      state.procedureMod = action.payload; // Update modifying state
    },
  },
  //   extraReducers: (builder) => {
  //     builder;
  //   },
});

export const { setModifying, setPropertyMod, setProcedureMod } =
  ModifySlice.actions;

export const selectIsModifying = (state) => state.Modify.isModifying;
export const selectPropertyMod = (state) => state.Modify.propertyMod;
export const selectProcedureMod = (state) => state.Modify.procedureMod;

export default ModifySlice.reducer;
